module.exports = __webpack_public_path__ + "img/calendar.3582aa35.png";